import { render, staticRenderFns } from "./PromoCode.vue?vue&type=template&id=17b5dd7c"
import script from "./PromoCode.vue?vue&type=script&lang=ts"
export * from "./PromoCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports